export default function SolutionSection() {
  return (
    <section id="solution" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Zone gauche - Éléments visuels */}
          <div className="relative">
            <div className="text-xs font-light text-[#6B5D54] mb-8 tracking-wider">• Méthode hospitalière</div>
            
            {/* Titre principal */}
            <h2 className="text-5xl md:text-6xl font-bold text-[#1A1A1A] mb-6 leading-tight" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Une méthode<br />
              <span className="text-[#E8956F]">validée</span><br />
              scientifiquement
            </h2>

            <p className="text-lg text-[#6B6B6B] leading-relaxed mb-8">
              La sophrologie est reconnue par le corps médical et utilisée dans de nombreux hôpitaux pour accompagner les patientes atteintes d'endométriose. Cette formation adapte ces protocoles au monde équestre.
            </p>

            {/* Statistiques */}
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-[#FAF7F4] rounded-2xl p-6">
                <div className="text-4xl font-bold text-[#3D2817] mb-2">87%</div>
                <p className="text-sm text-[#6B6B6B]">Réduction de la douleur ressentie</p>
              </div>
              <div className="bg-[#FAF7F4] rounded-2xl p-6">
                <div className="text-4xl font-bold text-[#3D2817] mb-2">92%</div>
                <p className="text-sm text-[#6B6B6B]">Amélioration de la qualité de vie</p>
              </div>
            </div>
          </div>

          {/* Zone droite - Titre principal */}
          <div>
            <div className="text-xs font-light text-[#6B5D54] mb-6 tracking-wider">/solution reconnue</div>
            <h2 className="text-5xl md:text-6xl lg:text-7xl font-thin text-[#2C1810] leading-tight mb-8" style={{ fontFamily: 'Montserrat, sans-serif', letterSpacing: '-0.02em' }}>
              La sophrologie :<br />
              une méthode reconnue<br />
              pour la gestion de la douleur
            </h2>
          </div>
        </div>

        {/* Contenu explicatif */}
        <div className="mt-16 grid md:grid-cols-2 gap-12">
          <div>
            <h3 className="text-2xl font-bold text-[#3D2817] mb-6">Une méthode éprouvée</h3>
            <p className="text-[#6B6B6B] leading-relaxed mb-4">
              La sophrologie est une méthode reconnue de gestion de la douleur, utilisée depuis des années en milieu hospitalier et médical, notamment dans l'accompagnement des douleurs chroniques, des pathologies gynécologiques, des cancers et des troubles psychosomatiques.
            </p>
            <p className="text-[#6B6B6B] leading-relaxed">
              C'est une méthode structurée, éprouvée, avec des résultats concrets sur la douleur et son impact au quotidien.
            </p>
          </div>

          <div>
            <h3 className="text-2xl font-bold text-[#3D2817] mb-6">Elle agit directement sur :</h3>
            <div className="space-y-3">
              {[
                "L'intensité de la douleur",
                'La régulation du système nerveux',
                'La détente neuromusculaire',
                'La respiration',
                'La gestion du stress'
              ].map((item, index) => (
                <div key={index} className="flex items-center gap-3 bg-white p-4 rounded-xl">
                  <div className="w-8 h-8 bg-[#E8956F] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white"></i>
                  </div>
                  <span className="text-[#3A3A3A] font-medium">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Section formation spécifique */}
        <div className="mt-20 bg-white rounded-3xl p-12 shadow-sm">
          <h3 className="text-3xl md:text-4xl font-bold text-[#3D2817] mb-6 text-center" style={{ fontFamily: 'Playfair Display, serif' }}>
            Une solution concrète, pensée spécifiquement pour les cavalières
          </h3>
          <p className="text-lg text-[#6B6B6B] text-center max-w-3xl mx-auto leading-relaxed mb-8">
            Face à ce constat, nous avons décidé d'apporter une solution claire, ciblée et efficace : une formation spécifiquement développée pour les cavalières atteintes d'endométriose.
          </p>
          
          <div className="grid md:grid-cols-2 gap-8 mt-12">
            <div className="bg-[#F9F5F2] p-6 rounded-2xl">
              <h4 className="text-xl font-bold text-[#3D2817] mb-4">L'objectif est simple et concret :</h4>
              <ul className="space-y-3">
                {[
                  'Aider les cavalières à mieux gérer leurs douleurs',
                  'Réduire l\'impact de l\'endométriose sur leur pratique',
                  'Retrouver de la mobilité, de la fluidité et du confort à cheval',
                  'Diminuer le stress et les tensions corporelles',
                  'Permettre au cheval de ne plus subir une douleur qui ne lui appartient pas'
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-2">
                    <i className="ri-arrow-right-s-line text-[#E8956F] text-xl mt-0.5"></i>
                    <span className="text-[#3A3A3A]">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="flex items-center justify-center">
              <img 
                src="https://public.readdy.ai/ai/img_res/45c17e1d5411632719dae1b834ef57ac.jpg"
                alt="Pratique de la sophrologie"
                className="w-full h-full object-cover object-top rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}